import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey'
import { CommonEventProperties } from '../../utils/CommonParams'

export const SearchBarViewEventSchema = (): EventSchema => {
  return {
    eventName: EN.SEARCH_BAR_VIEW,
    params: {
      // common properties
      ...CommonEventProperties,
            
      // specific properties
      BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
      EVENT_CATEGORY: EPK.EVENT_CATEGORY,
      SEARCH_SUGGESTED_CAMPAIGN_NAME: EPK.SEARCH_SUGGESTED_CAMPAIGN_NAME,
    },
  }
}
